/* Estilos y clases Raiz */
:root {
  --blue-1: rgb(10, 85, 239);
  --blue-1-50: rgba(10, 86, 239, 0.5);
  --blue-2: rgb(0, 37, 87);
  --blue-2-50: rgb(8, 41, 97);
  --white: rgb(255, 255, 255);
  --black: rgb(38, 38, 38);
  --black-50: rgba(38, 38, 38, 0.473);
  --black-75: rgba(38, 38, 38, 0.664);
  --warning: rgb(255, 190, 65);
  --danger: rgb(229, 48, 48);
  --success: rgb(229, 48, 48);
  --primary: rgb(10, 85, 239);
}
.background-2 {
  background-color: var(--blue-2-50);
}
.background-primary {
  background-color: var(--blue-2);
}
.background-secondary {
  background-color: var(--blue-1);
}
.background-warning {
  background-color: var(--warning);
}
.icon-login {
  height: 5rem;
  width: 5rem;
  background-color: var(--white);
  border-radius: 50%;
}
.icon-avatar-user {
  max-width: 100%;
  max-height: auto;
  background-color: var(--white);
  border-radius: 50%;
}
.icon {
  height: 1rem;
  width: 1rem;
}
.scrollTopBtn {
  position: fixed;
  top: 90vh;
  left: 94vw;
  z-index: 1000;
}
.rotate-icon-45 {
  display: inline-block;
  transform: rotate(45deg);
}
.cursor-pointer {
  cursor: pointer;
}

/* Estilos para la scroll-bar */
.scroll-section-login {
  max-height: 85dvh;
}
.scroll-secction {
  max-height: 85dvh;
}
.scroll-secction,
.scroll-section-login {
  overflow-x: auto;
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #ccc transparent; /* Firefox */
}
.scroll-secction::-webkit-scrollbar,
.scroll-secction-login::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}
.scroll-secction::-webkit-scrollbar-track,
.scroll-section-login::-webkit-scrollbar-track {
  background: transparent;
}
.scroll-secction::-webkit-scrollbar-thumb,
.scroll-section-login::-webkit-scrollbar-thumb {
  background-color: #999;
  border-radius: 10px;
  border: 2px solid transparent;
  background-clip: content-box;
}
.scroll-secction::-webkit-scrollbar-thumb:hover,
.scroll-section-login::-webkit-scrollbar-thumb:hover{
  background-color: #666;
}


body {
  width: 100dvw;
  height: 100dvh;
  overflow: hidden;
}

/* Estilos para los inputs */
input, 
select,
textarea {
  cursor: pointer;
}
input:disabled, 
select:disabled,
button:disabled {
  cursor: not-allowed;
}
input[type="text"]:focus {
  cursor: text;
}

/* Estilos para la tabla */
table {
  width: 100%;
}
table thead {
  color: var(--white);
  background-color: var(--primary);
}
table > thead > tr th > span {
  cursor: pointer;
}
table > thead > tr th,
table > tbody > tr td{
  text-align: center;
  padding: 0.3rem 1rem
}
table > tbody tr {
  border-style: solid;
  border-width: 1px;
  border-color: transparent transparent var(--primary) transparent;
}
table > tbody tr:hover {
  background-color: var(--blue-1-50);
  transition: all 0.4s;
}

/* Estilos de Página 404*/
